import { render, staticRenderFns } from "./SmallIconButton.vue?vue&type=template&id=c18c9e72&"
import script from "./SmallIconButton.vue?vue&type=script&lang=js&"
export * from "./SmallIconButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports